import { MyExperienceResolver } from "./my-experience.resolver";
import { QRCodeResolver } from "./qr-code.resolver";
import { ScanCodeResolver } from "./scan-code.resolver";
import { UserInfoResolver } from "./user-info.resolver";

export const CORE_RESOLVERS = [ScanCodeResolver, UserInfoResolver, QRCodeResolver, MyExperienceResolver];
